'use client'

import * as React from 'react'
import type { AbstractIntlMessages } from 'next-intl'
import { NextIntlClientProvider } from 'next-intl'
import { defaultLanguage } from 'cf-i18n/constants'
import type { Language } from 'codegen/types'

import type { UserAuthDialogProps } from './user-auth-dialog'
import { UserAuthDialog as UserAuthDialogComponent } from './user-auth-dialog'

export function UserAuthDialog({
  locale = defaultLanguage,
  ...userAuthDialogProps
}: {
  locale?: Language
} & UserAuthDialogProps) {
  const [i18n, setI18n] = React.useState<AbstractIntlMessages | null>(null)

  React.useEffect(() => {
    async function fetchMessages() {
      const messages = await import(`./i18n/${locale}.json`)
      setI18n(messages.default)
    }

    fetchMessages()
  })

  if (i18n === null) {
    return null
  }

  return (
    <NextIntlClientProvider locale={locale} messages={i18n}>
      <UserAuthDialogComponent {...userAuthDialogProps} />
    </NextIntlClientProvider>
  )
}
